import React, {useRef} from "react";
import {useSetState} from "ahooks";
import {
  SActionBtn,
  SDrawerOrModal,
  SLowcodeList,
  SSkuCard,
  STableActions,
  STags
} from "shj-components";

import { config } from './config.jsx'
import SKUDetailsModal from "@/pages/productManage/components/SKUDetailsModal";
import { productCombinationDetailSelectList } from "@/services/product.ts";
import { Tooltip } from "antd";
import dayjs from "dayjs";

const CombinationDetailsModal = (props) => {
  const {open, onClose, record, onReload} = props;
  const listRef = useRef();
  const [state, setState] = useSetState({
    open: false,
    record: {},
  })

  const fetchList = ({query}) => {
    return new Promise( (resolve, reject) => {
      if (query.currentDate){
        query.currentDate = dayjs(query.currentDate).format('YYYY-MM-DD')
      }
      productCombinationDetailSelectList({ mainProductId: record.id, queryApplyProductShop: true, ...query}).then((res: any) => {
        resolve({ records: res })
      }).catch(reject)
    })
  }

  const onReloadList = () => {

  }

  const toEdit = () => {
    window.open(`/config/combinationManage?mainId=${record.id}`, '_blank')
  }

  const extension = {
    request: { fetchList },
    events: { toEdit },
    scroll: { x: '100%', y: 'calc(100vh - 200px)' },
    tableType: 'antd',
    rowSelection: {
      onChange: (selectedRowKeys, selectedRows) => {
        console.log(selectedRowKeys, selectedRows);
      },
    },
    customRender: {
      renderProduct(_, record: Record<string, any>) {
        return (
          <SSkuCard
            width={'100%'}
            url={record.mainPicUrl || ''}
            desc={record.productId}
            operation={() => {
              return <div></div>
            }}
            title={
              <Tooltip title={record.prodName}>
                <div style={{wordBreak: 'break-all', whiteSpace: 'wrap'}}>{record.prodName}</div>
              </Tooltip>
            }
          ></SSkuCard>
        )
      },
      shopNameRender(v) {
        const names = v?.map?.(item => item.companyName)
        return names?.join?.(', ')
      },
      actionRender: (id, record) => {
        return <STableActions>
          <SActionBtn onClick={() => setState({open: true, record})}>SKU详情</SActionBtn>
        </STableActions>
      },
      enabledRender(v) {
        return <STags
          itemKey=""
          label={v ? '启用' : '禁用'}
          fontColor={v ? '#00A865' : '#EB3723'}
          bgColor={v ? '#D7F7EA' : '#FFEAE8'}
        />
      },
    }
  }

  return <>
    <SDrawerOrModal
      title={'组合明细'}
      width={1000}
      open={open}
      loading={false}
      onCancel={onClose}
      antdProps={{
        footer: null
      }}
    >
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extension}/>
    </SDrawerOrModal>
    {state.open && <SKUDetailsModal
      title={'SKU详情'}
      open={state.open}
      spuData={state.record}
      onClose={() => setState({ open: false })}
      onReload={onReloadList}
    />}
  </>
}

export default CombinationDetailsModal